import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGoogle, faWhatsapp, faFacebook } from '@fortawesome/free-brands-svg-icons';
import { faChevronLeft, faChevronRight, faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import ServiceList from '../components/ServiceList';
import BankCarousel from '../components/BankCarousel';
import FAQSection from '../components/FAQSection';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

import articles from '../data/articlesData';
import services from '../data/servicesData';
const testimonials = [
  {
    id: 1,
    text: "התרשמתי מאביעד מכל כך הרבה דברים טובים, אביעד מקצועי מאוד, עם ידע רחב , מסביר מעולה, אדיב, מקצועי, נעים, זמין, אביעד פשוט אלוף!!!",
    author: "ספיר ו.",
    source: "Google",
  },
  {
    id: 2,
    text: "אין מילים לתאר כמה אנחנו מרוצים ממחזור המשכנתא שעשינו עם אביעד! הוא ליווה אותנו לאורך כל התהליך, הסביר כל שלב בצורה פשוטה וברורה, והשיג לנו ריביות מצוינות שהורידו משמעותית את ההחזרים החודשיים. אביעד היה סבלני, מקצועי ואמין, והצלחנו לחסוך מלא כסף שהיה הולך לבנק.",
    author: "נועה ג.",
    source: "Facebook",
  },
  {
    id: 3,
    text: "אחלה שירות אני מרוצה מאוד",
    author: "עילאי ג.",
    source: "Google",
  },
  {
    id: 4,
    text: "זכינו במחיר למשתכן, אביעד עזר לנו להבין את כל תהליך המשכנתא ולהשיג תנאים מאוד טובים והחזר חודשי נמוך ממה שציפינו. מקצועי וסבלני, ליווה אותנו בכל צעד ועשה את כל המורכבויות הרבה יותר פשוטות .    ",
    author: "גוני ד.",
    source: "Facebook",
  },
  {
    id: 5,
    text: "מקצוען ,יודע את העבודה יסודי מאוד ויודע להביא תוצאות איכותיות",
    author: "אברהם ל.",
    source: "Google",
  },
  {
    id: 6,
    text: "מקצועי ואמין",
    author: "אסף ז.",
    source: "Google",
  },
  {
    id: 7,
    text: "לאחר התלבטויות רבות, פנינו למשכנתא מניסיון וקיבלנו שירות מהשורה הראשונה! אמינות יוצאת דופן, שקיפות מוחלטת לאורך כל התהליך, והכי חשוב – השיגו לנו ריביות מטורפות וחסכו לנו המון כסף. השירות היה אישי ומותאם לצרכים שלנו, וידענו שיש לנו על מי לסמוך בכל שלב. אם אתם מחפשים יועץ משכנתאות אמין ומקצועי, זה המקום בשבילכם! תודה רבה לאביעד עזריאל על עבודה מצוינת",
    author: "מאירה ל",
    source: "Facebook",
  },
];
const faqData = [
  {
    question: "מה ההבדל בין סוגי הריביות במשכנתא?",
    answer: (<>
      <p>ישנם סוגי ריביות שונים במשכנתא, כולל ריבית קבועה, ריבית משתנה וריבית פריים:</p>
      <ul>
        <li><strong>ריבית קבועה:</strong> הריבית נשארת קבועה לאורך כל תקופת ההלוואה, מה שמאפשר תכנון מדויק של ההחזר החודשי ואינו מושפע מהעלאות ריבית עתידיות. זהו מסלול בטוח יותר, אך בדרך כלל הריבית תהיה גבוהה יותר בהשוואה לריבית משתנה.</li>
        <li><strong>ריבית משתנה:</strong> הריבית משתנה בהתאם לשיעור הריבית בשוק, בדרך כלל אחת לכמה חודשים או שנים. זה יכול להוביל לתשלומים חודשיים נמוכים יותר בהתחלה, אך יש סיכון שהריבית תעלה בעתיד, מה שיכול להגדיל את התשלומים החודשיים.</li>
        <li><strong>ריבית פריים:</strong> זוהי ריבית משתנה שמבוססת על ריבית בסיסית, לרוב ריבית בנק ישראל, בתוספת מרווח קבוע. זהו מסלול גמיש שיכול להיות משתלם, אך גם כאן יש סיכון לתנודתיות.</li>
      </ul>
      </>)
    ,
  },
  {
    question: "איך מתבצע תהליך קבלת המשכנתא?",
    answer: (<>
      <p>תהליך קבלת המשכנתא כולל מספר שלבים עיקריים:</p>
      <ol>
        <li><strong>1. פגישת ייעוץ:</strong> בשלב הראשון, כדאי לקבוע פגישה עם יועץ משכנתאות או בנקאי, שיסייע לכם להבין את האפשרויות הזמינות.</li>
        <li><strong>2. איסוף מסמכים:</strong> יש לאסוף את המסמכים הנדרשים, כגון תעודת זהות, תלושי שכר, דוחות מס, ואישור על הכנסות נוספות.</li>
        <li><strong>3. הגשת בקשה לבנק:</strong> לאחר שהכנתם את המסמכים, יש להגיש את הבקשה לבנק או לגוף המלווה.</li>
        <li><strong>4. קבלת אישור עקרוני:</strong> הבנק יבצע בדיקות ויוציא אישור עקרוני, שמצביע על כך שאתם עומדים בתנאים לקבלת ההלוואה.</li>
        <li><strong>5. חתימה על המשכנתא:</strong> לאחר קבלת האישור הסופי, תתבצע החתימה על ההסכם והכספים ישוחררו לרכישת הנכס.</li>
      </ol>
      </>)
    ,
  },
  {
    question: "מה חשוב לדעת על מחזור משכנתא?",
    answer: (<>
      <p>מחזור משכנתא הוא תהליך שבו לוקחים הלוואה חדשה כדי להחליף את ההלוואה הקיימת, לרוב במטרה לשפר את התנאים:</p>
      <ul>
        <li><strong>חיסכון בכסף:</strong> מחזור יכול לחסוך כסף במידה והתנאים הכלכליים השתנו (כגון ירידת ריבית) או שהמשכנתא הראשונית לא תואמת לצרכים הנוכחיים שלכם.</li>
        <li><strong>התאמה לצרכים חדשים:</strong> אם המציאות הכלכלית שלכם השתנתה (כמו שינוי בהכנסות או הוצאות), מחזור יכול לאפשר לכם להתאים את המשכנתא למצבכם הנוכחי.</li>
        <li><strong>ייעוץ מקצועי:</strong> חשוב להתייעץ עם מומחה לפני שמבצעים מחזור, שכן ישנם פרטים רבים שצריך לקחת בחשבון כמו עלויות מחזור, ריביות והאם יש קנס על פירעון מוקדם.</li>
      </ul>
    </>),
  },
  {
    question: "כיצד יועץ משכנתאות יכול לעזור לי?",
    answer: (<>      <p>יועץ משכנתאות מקצועי מציע מגוון שירותים שיכולים להקל עליכם בתהליך רכישת הדירה:</p>
      <ul>
        <li><strong>הבנת אפשרויות:</strong> היועץ יכול לעזור לכם להבין את האפשרויות השונות הקיימות בשוק, ולסייע בבחירה בין סוגי המשכנתאות.</li>
        <li><strong>תמהיל הלוואה נכון:</strong> הוא יכול לסייע לכם לבחור את תמהיל ההלוואה הנכון, כך שתוכלו לקבל את התנאים הטובים ביותר בהתאם למצבכם הכלכלי.</li>
        <li><strong>שיפור תנאים פיננסיים:</strong> יועץ מנוסה יכול לנהל משא ומתן עם הבנקים במקומכם, מה שיכול להוביל לחיסכון משמעותי בהחזר החודשי ובסך ההוצאות הכוללות.</li>
        <li><strong>ליווי לאורך כל התהליך:</strong> יועץ משכנתאות מלווה אתכם בכל שלב בתהליך, מסביר מושגים פיננסיים מורכבים ומסייע בהכנת המסמכים הנדרשים.</li>
      </ul>
      </>
),
  },
];

const Home = () => {
  const [currentTestimonialIndex, setCurrentTestimonialIndex] = useState(0);
  const [fadeTransition, setFadeTransition] = useState(true);
  const [currentIndex, setCurrentIndex] = useState(0);
  const navigate = useNavigate();

  // Add these hooks for scroll animations
  const [aboutRef, aboutInView] = useInView({ threshold: 0.2, triggerOnce: true });
  const [servicesRef, servicesInView] = useInView({ threshold: 0.2, triggerOnce: true });
  const [testimonialsRef, testimonialsInView] = useInView({ threshold: 0.2, triggerOnce: true });

  const handleServiceClick = (serviceId) => navigate(`/services/${serviceId}`);
  const handleArticleClick = (id) => navigate(`/article/${id}`);
  const handleViewAllArticlesClick = () => navigate('/articles');
  const handleConsultationClick = () => navigate('/contact');
  const [articlesPerPage, setArticlesPerPage] = useState(
    window.innerWidth <= 768 ? 1 : window.innerWidth <= 1000 ? 2 : 3
  );
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setArticlesPerPage(1);
      } else if (window.innerWidth <= 1000) {
        setArticlesPerPage(2);
      } else {
        setArticlesPerPage(3);
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  
  
  useEffect(() => {
    const interval = setInterval(() => {
      setFadeTransition(false);
      setTimeout(() => {
        setCurrentTestimonialIndex((prevIndex) =>
          prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
        );
        setFadeTransition(true);
      }, 500);
    }, 5000);
    return () => clearInterval(interval);
  }, []);


  const currentTestimonial = testimonials[currentTestimonialIndex];
  const visibleArticles = articles.slice(currentIndex, currentIndex + articlesPerPage);


  const handleNext = () => setCurrentIndex((prevIndex) =>
    prevIndex + articlesPerPage < articles.length ? prevIndex + 1 : 0
  );

  const handlePrev = () => setCurrentIndex((prevIndex) =>
    prevIndex > 0 ? prevIndex - 1 : articles.length - articlesPerPage
  );

  return (
   <HomeContainer>
  


      <HeroSection>
        <Overlay />
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <HeroText>
            <h1>ברוכים הבאים למשכנתא מניסיון</h1>
            <p>השותף המהימן שלך בניווט מימון המשכנתא והשגת רוגע פיננסי.</p>
            <HeroButton onClick={handleConsultationClick}>קבל ייעוץ חינם</HeroButton>
          </HeroText>
        </motion.div>
      </HeroSection>




  <motion.div
    ref={aboutRef}
    initial={{ opacity: 0, y: 50 }}
    animate={aboutInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
    transition={{ duration: 0.8 }}
  >
    <AboutSection>
      <BackgroundPattern />
    
      <ContentContainer>
        <h2>אודותינו</h2>
        <Divider />
        <p>
          ברוכים הבאים ל<strong>משכנתא מניסיון</strong> – החברה שלכם לייעוץ משכנתאות אישי ומקצועי. בראשותי, אביעד עזריאל, יחד עם צוות של יועצים מומחים, אנחנו כאן כדי להוביל אתכם בביטחון בתהליך המשכנתא ולוודא שתקבלו את התנאים הטובים ביותר, תוך חסכון משמעותי בכספכם.
        </p>
        <p>
          לאחר שנים של ניסיון בבנק מזרחי טפחות בתחום ניהול סיכוני שוק ואשראי, הקמתי את משכנתא מניסיון מתוך חזון לעזור לכל לקוח למצוא את הפתרון המושלם לצרכיו. אנחנו כאן לכל שאלה, ללוות אתכם בכל שלב ולספק מענה מדויק – מהתכנון הראשוני ועד להשגת התנאים המשתלמים ביותר עבורכם.
        </p>
        <p>
          כחלק מהמקצועיות והמחויבות שלנו, אנו גאים להיות חלק מהתאחדות יועצי המשכנתאות בישראל.
        </p>

      </ContentContainer>
      <LogoContainer>
        <img src={`${process.env.PUBLIC_URL}/logo22.png`} alt="Company Logo" /> {/* לוגו העסק */}
        <img src="https://hfca.org.il/wp-content/uploads/2021/12/logob@4x-8.png" alt="Association Logo" /> {/* לוגו ההתאחדות */}
      </LogoContainer>
    </AboutSection>
  </motion.div>


      <motion.div
        ref={servicesRef}
        initial={{ opacity: 0, y: 50 }}
        animate={servicesInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
        transition={{ duration: 0.8 }}
      >
        <ServicesSection>
          <h2>השירותים שלנו</h2>
          <ServiceList services={services} onCardClick={handleServiceClick} />
        </ServicesSection>
      </motion.div>

      <motion.div
        ref={testimonialsRef}
        initial={{ opacity: 0, y: 50 }}
        animate={testimonialsInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
        transition={{ duration: 0.8 }}
      >
        <TestimonialsSection>
          <h2>מה הלקוחות שלנו אומרים</h2>
          <TestimonialCard fadeTransition={fadeTransition}>
            <PlatformIcon source={currentTestimonial.source}>
              <FontAwesomeIcon icon={currentTestimonial.source === "Google" ? faGoogle : faFacebook} />
            </PlatformIcon>
            <p>"{currentTestimonial.text}"</p>
            <Author>{currentTestimonial.author}</Author>
            <Source>חוות דעת מ- {currentTestimonial.source}</Source>
          </TestimonialCard>
        </TestimonialsSection>
      </motion.div>

      <ArticlesSection>
        <h2>מאמרים אחרונים</h2>
        <ArticleCarousel>
        <Arrow onClick={handleNext}><FontAwesomeIcon icon={faChevronRight} /></Arrow>
          <ArticleGrid>
            {visibleArticles.map((article) => (
              <ArticleCard key={article.id} onClick={() => handleArticleClick(article.id)}>
                <ArticleImage src={article.image} alt={article.title} />
                <h3>{article.title}</h3>
                <p>{article.description}</p>
              </ArticleCard>
            ))}
          </ArticleGrid>
          <Arrow onClick={handlePrev}><FontAwesomeIcon icon={faChevronLeft} /></Arrow>
          
        </ArticleCarousel>
        <ViewAllLink onClick={handleViewAllArticlesClick}>צפה בכל המאמרים</ViewAllLink>
      </ArticlesSection>
      
     
      
      <CarouselSection>
        <h3>גופי מימון</h3>
        <BankCarousel />
      </CarouselSection>

      <FAQSection faqData={faqData}/>

      <CTASection>
        <h2>מוכן לקחת שליטה על המשכנתא שלך?</h2>
        <CTAButton onClick={handleConsultationClick}>קבע פגישה לייעוץ חינם</CTAButton>
        <IconsContainer>
          <IconLink href="tel:+972508857282" color="#4CAF50"><FontAwesomeIcon icon={faPhone} /></IconLink>
          <IconLink href="mailto:contact@premiumconsult.com" color="#DB4437"><FontAwesomeIcon icon={faEnvelope} /></IconLink>
          <IconLink href="https://wa.me/972508857282" target="_blank" rel="noopener noreferrer" color="#4CAF50"><FontAwesomeIcon icon={faWhatsapp} /></IconLink>
          <IconLink href="https://facebook.com" target="_blank" rel="noopener noreferrer" color="#3b5998"><FontAwesomeIcon icon={faFacebook} /></IconLink>
        </IconsContainer>
      </CTASection>
    </HomeContainer>
  );
};


const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    rgba(0, 0, 0, 0.5), /* Darker at the top */
    rgba(0, 0, 0, 0.2) /* Lighter at the bottom */
  );
  z-index: 1;
`;
const HeroSection = styled.section`
  position: relative;
  background-image: url(${process.env.PUBLIC_URL}/family2.webp);
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  color: white;
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 20px;
  overflow: hidden;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
     background: linear-gradient(
      rgba(0, 0, 0, 0.6), /* Dark at the top */
      rgba(0, 0, 0, 0.3) /* Lighter at the bottom */
    );
    opacity: 0.7; /* Adjust opacity for desired subtlety */

    z-index: 1;
  }

  @media (max-width: 768px) {
    height: 70vh;
    padding: 15px;
  }
`;

const HeroText = styled.div`
  position: relative;
  z-index: 2;
  max-width: 800px;
  padding: 0 20px;

  h1 {
    font-size: 3.5rem;
    font-weight: bold;
    margin: 0;
    color: #ffffff;
    text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.6);
    line-height: 1.2;
  }

  p {
    font-size: 1.4rem;
    margin-top: 20px;
    color: #f0f0f0;
    text-shadow: 1px 1px 6px rgba(0, 0, 0, 0.6);
    line-height: 1.6;
  }

  @media (max-width: 768px) {
    h1 {
      font-size: 2.2rem;
    }
    p {
      font-size: 1.1rem;
      margin-top: 15px;
    }
  }
`;

const HeroButton = styled.button`
  background-color: #fcbf49;
  color: #0d1b2a;
  padding: 15px 35px;
  border: none;
  border-radius: 30px;
  font-size: 1.2rem;
  font-weight: 600;
  cursor: pointer;
  margin-top: 30px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);

  &:hover {
    background-color: #f0a500;
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.25);
  }

  &:active {
    transform: translateY(1px);
  }

  @media (max-width: 768px) {
    padding: 12px 25px;
    font-size: 1rem;
    margin-top: 20px;
  }
`;

// Styled Components
const HomeContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;

  @media (max-width: 768px) {
    padding: 0px;
  }
`;

const AboutSection = styled.section`
  position: relative;
  display: flex;
  max-width: 1400px;
  padding: 80px 40px;
  margin: 60px auto;
  background-color: #ffffff;
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  overflow: hidden;

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 40px 20px;
    margin: 30px auto;
  }
`;

const BackgroundPattern = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('/path/to/background-pattern.svg'); /* Path to a subtle background pattern */
  opacity: 0.1;
  z-index: 0;
  pointer-events: none;
`;

const LogoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 30px;
  padding: 20px;
  z-index: 1;

  img {
    max-width: 220px;
    height: auto;
    transition: transform 0.3s ease;

    &:hover {
      transform: scale(1.05);
    }
  }

  img:first-child {
    border-radius: 15px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  }

  @media (max-width: 768px) {
    flex-direction: row;
    margin-top: 30px;
    gap: 20px;

    img {
      max-width: 150px;
    }
  }
`;

const ContentContainer = styled.div`
  flex: 1;
  z-index: 1;
  padding-right: 40px;

  h2 {
    font-size: 2.5rem;
    color: #1b263b;
    margin-bottom: 20px;
    font-weight: 700;
  }

  p {
    font-size: 1.1rem;
    line-height: 1.8;
    color: #4a5568;
    margin-bottom: 20px;
    text-align: right;
  }

  strong {
    color: #1b263b;
    font-weight: 700;
  }

  @media (max-width: 768px) {
    padding-right: 0;
    text-align: center;

    h2 {
      font-size: 2rem;
    }

    p {
      font-size: 1rem;
      text-align: center;
    }
  }
`;

const Divider = styled.div`
  width: 60px;
  height: 4px;
  background-color: #fcbf49;
  margin: 10px 0 25px;
  border-radius: 2px;
`;

const CarouselSection = styled.section`
  width: 100%;
  text-align: center;
  padding: 40px 0;

  h3 {
    font-size: 1.5rem;
    margin-bottom: 20px;
    color: #1b263b;
  }
`;

const TestimonialsSection = styled.section`
  max-width: 1000px;
  padding: 80px 20px;
  text-align: center;
  margin: auto;

  h2 {
    font-size: 2.5rem;
    color: #1b263b;
    margin-bottom: 40px;
    font-weight: 700;
    position: relative;

    &:after {
      content: '';
      position: absolute;
      bottom: -15px;
      left: 50%;
      transform: translateX(-50%);
      width: 80px;
      height: 4px;
      background-color: #fcbf49;
      border-radius: 2px;
    }
  }

  @media (max-width: 768px) {
    padding: 40px 20px;

    h2 {
      font-size: 2rem;
      margin-bottom: 30px;
    }
  }
`;

const TestimonialCard = styled.div`
  background: #ffffff;
  padding: 40px;
  margin: 20px auto;
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  width: 100%;
  max-width: 700px;
  min-height: 250px;
  transition: all 0.5s ease-in-out;
  opacity: ${(props) => (props.fadeTransition ? 1 : 0)};
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;

  p {
    font-size: 1.2rem;
    color: #4a5568;
    font-style: italic;
    line-height: 1.8;
    margin: 20px auto;
    max-width: 90%;
  }

  @media (max-width: 768px) {
    padding: 30px 20px;
    min-height: 200px;

    p {
      font-size: 1rem;
    }
  }
`;

const PlatformIcon = styled.div`
  position: absolute;
  top: 15px; /* Adjusted for visibility */
  left: 20px;
  font-size: 1.5rem;
  color: ${({ source }) => (source === "Google" ? "#DB4437" : "#4267B2")};
`;

const Author = styled.h4`
  font-size: 1rem;
  color: #0d1b2a;
  margin-top: 10px;
`;

const Source = styled.span`
  font-size: 0.8rem;
  color: #888;
`;

const ServicesSection = styled.section`
  width: 100%;
  max-width: 1200px;
  padding: 80px 20px;
  text-align: center;

  h2 {
    font-size: 2.5rem;
    color: #1b263b;
    margin-bottom: 40px;
    font-weight: 700;
    position: relative;

    &:after {
      content: '';
      position: absolute;
      bottom: -15px;
      left: 50%;
      transform: translateX(-50%);
      width: 80px;
      height: 4px;
      background-color: #fcbf49;
      border-radius: 2px;
    }
  }

  @media (max-width: 768px) {
    padding: 40px 20px;

    h2 {
      font-size: 2rem;
      margin-bottom: 30px;
    }
  }
`;

const ArticlesSection = styled.section`
  width: 100%;
  max-width: 1200px;
  padding: 80px 20px;
  text-align: center;
  background-color: #f8fafc;
  border-radius: 20px;
  margin: 40px auto;

  h2 {
    font-size: 2.5rem;
    color: #1b263b;
    margin-bottom: 40px;
    font-weight: 700;
    position: relative;

    &:after {
      content: '';
      position: absolute;
      bottom: -15px;
      left: 50%;
      transform: translateX(-50%);
      width: 80px;
      height: 4px;
      background-color: #fcbf49;
      border-radius: 2px;
    }
  }

  @media (max-width: 768px) {
    padding: 40px 15px;
    margin: 20px auto;

    h2 {
      font-size: 2rem;
      margin-bottom: 30px;
    }
  }
`;

const ArticleCarousel = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  padding: 20px 0;
`;

const ArticleGrid = styled.div`
  display: flex;
  justify-content: center;
  gap: 30px;
  margin: 0 auto;
  max-width: 1000px;

  @media (max-width: 1000px) {
    gap: 20px;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`;

const Arrow = styled.div`
  cursor: pointer;
  font-size: 2.5rem;
  color: #1b263b;
  transition: all 0.3s ease;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.9);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);

  &:hover {
    color: #fcbf49;
    transform: scale(1.1);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
  }

  @media (max-width: 768px) {
    font-size: 2rem;
    width: 40px;
    height: 40px;
  }
`;

const ArticleCard = styled.div`
  background: #ffffff;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  width: 320px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 15px 40px rgba(0, 0, 0, 0.12);
  }

  h3 {
    font-size: 1.3rem;
    margin: 15px 0;
    color: #1b263b;
    padding: 0 20px;
    font-weight: 600;
  }

  p {
    font-size: 1rem;
    color: #4a5568;
    padding: 0 20px 20px;
    line-height: 1.6;
  }

  @media (max-width: 768px) {
    width: 100%;
    max-width: 320px;
  }
`;

const ArticleImage = styled.img`
  width: 100%;
  height: 180px;
  object-fit: cover;
  transition: transform 0.3s ease;

  ${ArticleCard}:hover & {
    transform: scale(1.05);
  }
`;

const ViewAllLink = styled.button`
  background: none;
  border: 2px solid #fcbf49;
  color: #1b263b;
  font-weight: 600;
  font-size: 1.1rem;
  margin-top: 40px;
  padding: 12px 30px;
  border-radius: 30px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background-color: #fcbf49;
    color: #ffffff;
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  }

  &:active {
    transform: translateY(1px);
  }
`;

const CTASection = styled.section`
  background: linear-gradient(135deg, #1b263b 0%, #2a4365 100%);
  color: #ffffff;
  padding: 80px 40px;
  text-align: center;
  border-radius: 30px;
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.15);
  margin: 60px auto;
  width: 90%;
  max-width: 1000px;

  h2 {
    font-size: 2.5rem;
    margin-bottom: 30px;
    font-weight: 700;
    line-height: 1.3;
  }

  @media (max-width: 768px) {
    padding: 40px 20px;
    margin: 30px auto;

    h2 {
      font-size: 1.8rem;
    }
  }
`;

const CTAButton = styled.button`
  background: #fcbf49;
  color: #1b263b;
  padding: 15px 35px;
  border: none;
  border-radius: 30px;
  font-size: 1.2rem;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;

  &:hover {
    background: #f0a500;
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.25);
  }

  &:active {
    transform: translateY(1px);
  }

  @media (max-width: 768px) {
    padding: 12px 25px;
    font-size: 1rem;
  }
`;

const IconsContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 25px;
  margin-top: 40px;

  @media (max-width: 768px) {
    gap: 15px;
    margin-top: 30px;
  }
`;

const IconLink = styled.a`
  background-color: ${({ color }) => color};
  color: white;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.8rem;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);

  &:hover {
    transform: translateY(-3px) scale(1.1);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);
  }

  &:active {
    transform: translateY(1px);
  }

  @media (max-width: 768px) {
    width: 45px;
    height: 45px;
    font-size: 1.4rem;
  }
`;

export default Home;
